import type { CosignatureDocumentType } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export type RejectDocumentVariables = {
  documentId: string;
  documentType: CosignatureDocumentType;
  patientId: string;
  rejectionReason: string;
};

export async function rejectDocument({
  documentId,
  documentType,
  patientId,
  rejectionReason,
}: RejectDocumentVariables): Promise<void> {
  return cosignatureRequestsTyped.reject_document({
    data: {
      document_type: documentType,
      patient_id: patientId,
      rejection_reason: rejectionReason,
    },
    documentId,
  });
}
